
const validateResponseError = (ctx, error, store) => {
    console.log(error);
    if (error.response) {
        if (error.response.status === 404) {
            ctx.commit(`${store}/SET_LAST_CALCULATION`, { finished_at: "No calculation found" })
            return
        }
        ctx.commit(`${store}/SET_LAST_CALCULATION`, { finished_at: "Error, something happen..." })
    }
}
export { validateResponseError };